module.exports = __webpack_public_path__ + "img/img4.62e53182.png";